export const deMenu = [
  
    {
      "id": 11,
      "title": "KROKO MADAM",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 12,
      "title": "MEDITERRANES OMELETT",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 13,
      "title": "ENGLISCHES FRÜHSTÜCK",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 14,
      "title": "BOUGATSA MIT CREME",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 15,
      "title": "BOUGATSA MIT FETA-KÄSE",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 16,
      "title": "TOAST",
      "category": "FRÜHSTÜCK",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 101,
      "title": "DAKOS",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "Carob dakos with mizithra cheese, tomato, olive, grebe, oregano"
    },
    {
      "id": 102,
      "title": "ΤΖΑΤΖΙΚΙ",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "Traditional tzatziki with garlic & dill"
    },
    {
      "id": 103,
      "title": "PIRGOS",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "Grilled vegetables with herb bulgur, balsamic vinaigrette, walnuts & feta mousse"
    },
    {
      "id": 104,
      "title": "PUMPKIN MEATBALLS ",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "with dill & yogurt sauce"
    },
    {
      "id": 105,
      "title": "GRILLED MUSHROOMS",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "with balsamic vinaigrette & black sesame"
    },
    {
      "id": 106,
      "title": "SAGANAKI",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "4 cheeses & tomato jam"
    },
    {
      "id": 107,
      "title": "PORTO BELLO",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "Goat cheese, bacon, hazelnut, balsamic cream"
    },
    {
      "id": 108,
      "title": "HOMEMADE FRIED POTATOES",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 109,
      "title": "PHYLLO ROLLS",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "with pastrami, cheese & yogurt sauce"
    },
    {
      "id": 110,
      "title": "DUSHA PALETTE",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "cheeses, cold cuts, fresh seasonal fruits, breadsticks, fig chutney"
    },
    {
      "id": 111,
      "title": "VEGETABLE SOUP",
      "category": "APPETIZER",
      "subCategory": "",
      "ingredients": "with fresh seasonal vegetables"
  },
  {
    "id": 112,
    "title": "CLUB SANDWICH CHICKEN",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 113,
    "title": "CLUB SANDWICH",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 114,
    "title": "MINI BURGER",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 115,
    "title": "TOAST",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 116,
    "title": "CHICKEN WITH POTATOES",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 117,
    "title": "POTATOES",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 118,
    "title": "MEAT PLATTER",
    "category": "APPETIZER",
    "subCategory": "",
    "ingredients": ""
  },
    {
      "id": 201,
      "title": "GREEK TRADITIONAL (VILLAGE SALAD)",
      "category": "SALADS",
      "subCategory": "",
      "ingredients": "Tomato, cucumber, onion, pepper, olive, feta cheese, cilantro & oregano"
    },
    {
      "id": 202,
      "title": "DUSHA SALAD",
      "category": "SALADS",
      "subCategory": "",
      "ingredients": "Tender lettuce leaves, cherry tomatoes, peach, balsamic vinaigrette, walnut, feta mousse & onion crackers"
    },
    {
      "id": 203,
      "title": "THE HEN'S NEST",
      "category": "SALADS",
      "subCategory": "",
      "ingredients": "Iceberg, chicken fillet, corn, honey vinaigrette, parmesan flakes on a cheese nest"
    },
    {
      "id": 204,
      "title": "TABOULE",
      "category": "SALADS",
      "subCategory": "",
      "ingredients": "Quinoa-bulgur, tomato pulp, onion, herbs, cucumber, goji berries"
    },
    {
      "id": 205,
      "title": "BURATTA",
      "category": "SALADS",
      "subCategory": "",
      "ingredients": "Baby spinach, buratta mozzarella, sweet chilli, cherry tomatoes & hazelnuts"
  },
  {
    "id": 206,
    "title": "CAESAR SALAD",
    "category": "SALADS",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 207,
    "title": "FRUIT SALAD",
    "category": "SALADS",
    "subCategory": "",
    "ingredients": ""
  },
    {
      "id": 301,
      "title": "FRIED SQUID*",
      "category": "SEAFOOD",
      "subCategory": "",
      "ingredients": "with Seafood tartare (* Products are frozen)"
    },
    {
      "id": 302,
      "title": "GRILLED OCTOPUS*",
      "category": "SEAFOOD",
      "subCategory": "",
      "ingredients": "with bulgur, tomato & fried onion (* Products are frozen)"
    },
    {
      "id": 303,
      "title": "SHRIMPS*",
      "category": "SEAFOOD",
      "subCategory": "",
      "ingredients": "grilled or saganaki with fresh tomato sauce (* Products are frozen)"
    },
    {
      "id": 304,
      "title": "SEA BASS",
      "category": "SEAFOOD",
      "subCategory": "",
      "ingredients": "Sea bass fillet with black vegetable rice"
    },
    {
      "id": 401,
      "title": "MUSHROOM RISOTTO or BARLEY RISOTTO",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "variety of wild Portobello mushrooms, porcini, pleurotus, parmesan & truffle oil"
    },
    {
      "id": 402,
      "title": "BARLEY or SEAFOOD RISOTTO",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Shrimp, squid, octopus with pink herb sauce"
    },
    {
      "id": 404,
      "title": "BARLEY VEGETARIAN",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Mushrooms, artichoke, zucchini, peppers, sweet pumpkin & cheese mousse"
    },
    {
      "id": 405,
      "title": "RIGATONI DUSHA",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Chicken, bacon, mushrooms, cream & parmesan"
    },
    {
      "id": 406,
      "title": "MEDITERRANEAN",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Linguine, pepper, olive, bacon & garlic"
    },
    {
      "id": 407,
      "title": "TAGALIATELE WITH SALMON",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Cream, garlic, lime & chives"
    },
    {
      "id": 408,
      "title": "SHRIMP* PASTA",
      "category": "PASTA / RIZOTTO",
      "subCategory": "",
      "ingredients": "Linguine, fresh tomato sauce, bisque, garlic oil  (* Products are frozen)"
    },
    {
      "id": 501,
      "title": "BUTTER LINGUINE",
      "category": "CHILDREN'S MENU",
      "subCategory": "",
      "ingredients": "with fresh tomato sauce"
    },
    {
      "id": 502,
      "title": "CHICKEN STICK",
      "category": "CHILDREN'S MENU",
      "subCategory": "",
      "ingredients": "Breaded chicken strips french fries, Dusha sauce"
    },
    {
      "id": 601,
      "title": "STAVLISIA ",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "Pork belly steak with baby potatoes"
    },
    {
      "id": 602,
      "title": "BURGER DUSHA",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "100% beef burger with egg, cheese, bacon, caramelized onion BBQ sauce and fresh fried potatoes"
    },
    {
      "id": 603,
      "title": "CHICKEN FILLET",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "grilled or schnitzel with mashed potatoes & Dijon"
    },
    {
      "id": 604,
      "title": "CHICKEN FILLET",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "caramelized pancetta with sweet potato puree & roast sauce"
    },
    {
      "id": 605,
      "title": "SWEET-SOUR",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "chicken, fried rice, julienne vegetables, sweet and sour sauce & black sesame"
    },
    {
      "id": 606,
      "title": "BIG SOUVLAKI PORK",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "with fresh potatoes, pita and herbs"
    },
    {
      "id": 607,
      "title": "BIG SOUVLAKI CHICKEN",
      "category": "MAIN DISH",
      "subCategory": "",
      "ingredients": "chicken leg, pita, new potato and dijon"
    },
    {
      "id": 701,
      "title": "LAMB RIBS",
      "category": "PREMIUM MEAT CUTS",
      "subCategory": "",
      "ingredients": "In premium dishes, garnishes are charged extra"
    },
    {
      "id": 702,
      "title": "RIBEYE",
      "category": "PREMIUM MEAT CUTS",
      "subCategory": "",
      "ingredients": "In premium dishes, garnishes are charged extra"
    },
    {
      "id": 801,
      "title": "GRECO",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "spinach, olives, feta cheese, cherry tomatoes,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 802,
      "title": "BELLA ITALIA",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "mozzarella, cherry tomatoes, serrano prosciutto, basil leavess,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 803,
      "title": "DUSHA",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "broccoli, chicken fillet, hollandaise sauces,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 804,
      "title": "PIZZA GYROS",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "tomato, onions"
    },
    {
      "id": 805,
      "title": "QUATTRO FORMAGGIE",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "Four cheesess,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 806,
      "title": "SPECIAL",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "ham, mushrooms, peppers,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 807,
      "title": "MARGARITA",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "with mozzarellas,  topped with fresh tomato sauce and gouda cheese"
    },
    {
      "id": 808,
      "title": "PEPERONI",
      "category": "PIZZA",
      "subCategory": "",
      "ingredients": "with salamis,  topped with fresh tomato sauce and gouda cheese"
  },
  {
    "id": 809,
    "title": "CHICKEN PIZZA ROLL",
    "category": "PIZZA",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 810,
    "title": "MOZZARELLA PIZZA ROLL",
    "category": "PIZZA",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 811,
    "title": "PROSCIUTTO PIZZA ROLL",
    "category": "PIZZA",
    "subCategory": "",
    "ingredients": ""
  },
    {
      "id": 901,
      "title": "CHOCOLATE SOUFFLE",
      "category": "DESSERTS",
      "subCategory": "",
      "ingredients": "with vanilla ice cream"
    },
    {
      "id": 902,
      "title": "TART",
      "category": "DESSERTS",
      "subCategory": "",
      "ingredients": "with fresh seasonal fruits"
    },
    {
      "id": 903,
      "title": "PROFITEROLL",
      "category": "DESSERTS",
      "subCategory": "",
      "ingredients": "with whipped cream and almond fillets"
    },
    {
      "id": 904,
      "title": "MILFAGE",
      "category": "DESSERTS",
      "subCategory": "",
      "ingredients": "with pastry cream"
  },
  {
    "id": 905,
    "title": "ICE CREAM ONE SCOOP",
    "category": "DESSERTS",
    "subCategory": "",
    "ingredients": ""
  },
    {
    id: 906,
    title: "EIS SORBET MANGO",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 907,
    title: "EIS MIT KEKSEN PRALINE",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 908,
    title: "EIS KEKSTEIG VANILLE MADAGASKAR",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 909,
    title: "EIS JOGHURT MIT FRÜCHTEN UND NÜSSEN",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 910,
    title: "EIS RICOTTA PISTAZIE RED VELVET CRUMBLE",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 911,
    title: "EIS SCHOKOLADE MIT BROWNIE-STÜCKCHEN",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 912,
    title: "EIS GIANDUJA MIT SCHOKO-KUGELN",
    category: "DESSERTS",
    subCategory: "",
    ingredients: "",
  },
    {
      "id": 1301,
      "title": "Espresso",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1302,
      "title": "Double espresso",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1303,
      "title": "Freddo espresso",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1304,
      "title": "Freddo cappuccino",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1305,
      "title": "Frappe",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1306,
      "title": "Greek coffee single",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1307,
      "title": "Greek coffee double",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1308,
      "title": "Cappuccino single",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1309,
      "title": "Cappuccino double",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1310,
      "title": "Latte",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1311,
      "title": "Americano",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1312,
      "title": "Hot chocolate",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1313,
      "title": "Iced chocolate",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1314,
      "title": "Filter coffee",
      "category": "COFFEE",
      "subCategory": "",
      "ingredients": ""
  },
  {
    "id": 1315,
    "title": "Macchiato",
    "category": "COFFEE",
    "subCategory": "",
    "ingredients": ""
  },
  {
    "id": 1316,
    "title": "Coffee with Ice Cream",
    "category": "COFFEE",
    "subCategory": "",
    "ingredients": ""
  },
    {
      "id": 1401,
      "title": "Orange",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1402,
      "title": "Sour cherry",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1403,
      "title": "Apple",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1404,
      "title": "Pineapple",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1405,
      "title": "Peach",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1406,
      "title": "Banana",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1407,
      "title": "Mixed",
      "category": "JUICES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1501,
      "title": "Homemade lemonade",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1502,
      "title": "Strawberry lemonade",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1503,
      "title": "Sour cherry",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1504,
      "title": "Granita Strawberry",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1505,
      "title": "Granita Lemon",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1506,
      "title": "Granita Mix",
      "category": "LEMONADES",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 1601,
      "title": "Aperol spritz",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Aperol bitter, prosecco, soda orange bitter"
    },
    {
      "id": 1602,
      "title": "Mojito",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Blanco rum, fresh lime, Caster sugar, fresh peppermint (flavours+1€)"
    },
    {
      "id": 1603,
      "title": "Margarita",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Premium bianco tequila, orange liqueur, fresh lime"
    },
    {
      "id": 1604,
      "title": "Cosmopolitan",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Citroen vodka, orange liqueur, fresh lime, cranberry juice"
    },
    {
      "id": 1605,
      "title": "Gin mule",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Dry gin, apple liqueur, fresh lime, gingerbeer"
    },
    {
      "id": 1606,
      "title": "Cherry blossom",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Blanco vermouth, cherry soda fresh berries & peppermint"
    },
    {
      "id": 1607,
      "title": "Passion martini",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Vodka vanilla, Passion liqueur, lime, sugar & fresh Passion"
    },
    {
      "id": 1608,
      "title": "Paloma",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Blanco tequila, fresh lime, grapefruit soda"
    },
    {
      "id": 1609,
      "title": "Mai-tai",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Jamaica blend rum, orange Curacao, almond syrup, fresh lime mix bitter"
    },
    {
      "id": 1610,
      "title": "Dusha royale",
      "category": "COCKTAILS",
      "subCategory": "",
      "ingredients": "Aperitivo pergamonti, champagne, Green olives"
    },
    {
      "id": 1701,
      "title": "Georgiadis Estate - Marble King",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Rodite-malagouzia"
    },
    {
      "id": 1702,
      "title": "Constantara Estate",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Sauvignon blanc"
    },
    {
      "id": 1703,
      "title": "Bosinakis Mantineia",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Moschofilero"
    },
    {
      "id": 1704,
      "title": "Iatridis estate",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Malagouzia"
    },
    {
      "id": 1705,
      "title": "Iatridis estate",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Assyrian"
    },
    {
      "id": 1706,
      "title": "Alpha estate",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Chardonnay"
    },
    {
      "id": 1707,
      "title": "Dark estate",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Viognier"
    },
    {
      "id": 1708,
      "title": "Estate books country - Ovilos",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Semillon-Assyrian"
    },
    {
      "id": 1709,
      "title": "Gavala Estate - Santorini",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Assyrian"
    },
    {
      "id": 1710,
      "title": "Domaine William - Fevre Chablis",
      "category": "WINE LIST",
      "subCategory": "WHITE WINE",
      "ingredients": "Chardonnay"
    },
    {
      "id": 1801,
      "title": "Pasqua mater Anna",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Pinot grigio"
    },
    {
      "id": 1802,
      "title": "Dryopi estate",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Agiorgitiko"
    },
    {
      "id": 1803,
      "title": "Mylona Estate",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Malagouzia - Mandilaria"
    },
    {
      "id": 1804,
      "title": "Iatridis Estate - Ampelourgos",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Assyrtiko -xinomavro"
    },
    {
      "id": 1805,
      "title": "Estate books country",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Syrah"
    },
    {
      "id": 1806,
      "title": "Oin. Grilemis",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Lake"
    },
    {
      "id": 1807,
      "title": "Estate la tour melas - Idylle d Achinos",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Agiortiko-grenache Rouge-syrah"
    },
    {
      "id": 1808,
      "title": "Lazaridis Estate",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Merlot"
    },
    {
      "id": 1809,
      "title": "Miraval",
      "category": "WINE LIST",
      "subCategory": "ROSE WINE",
      "ingredients": "Cinsault-grenache rouge-syrah-rolle"
    },
    {
      "id": 1901,
      "title": "Butari Naoussa",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Xinomavro"
    },
    {
      "id": 1902,
      "title": " Hotel Aivali Nemea",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Agiorgitiko"
    },
    {
      "id": 1903,
      "title": "Estate art of wine Art of alipia",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Cabernet sauvignon Agiorgitiko"
    },
    {
      "id": 1904,
      "title": "Estate Iatridis",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Syrah-black crisp"
    },
    {
      "id": 1905,
      "title": "Thymiopoulos Earth & Sky",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Xinomavro"
    },
    {
      "id": 1906,
      "title": " Bottle of wine (R)",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": "Merlot-syrah-xinomavro"
    },
    {
      "id": 1907,
      "title": "Bottle of Wine",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": ""
  },
    {
      "id": 1908,
      "title": "Bottle of Wine Premium",
      "category": "WINE LIST",
      "subCategory": "RED WINE",
      "ingredients": ""
    },
    {
      "id": 2001,
      "title": "Asolo 57 Prosecco Monteliana",
      "category": "WINE LIST",
      "subCategory": "SPARKLING",
      "ingredients": "Glera"
    },
    {
      "id": 2002,
      "title": "Prosecco Monteliana rosé",
      "category": "WINE LIST",
      "subCategory": "SPARKLING",
      "ingredients": "Glera-pinot noir"
    },
    {
      "id": 2003,
      "title": "Moscato Dasti Sollicelo",
      "category": "WINE LIST",
      "subCategory": "SPARKLING",
      "ingredients": "Moscato Bianco"
    },
    {
      "id": 2004,
      "title": "Asti martini",
      "category": "WINE LIST",
      "subCategory": "SPARKLING",
      "ingredients": "Moscato"
    },
    {
      "id": 2101,
      "title": "Moët chandon Brut imperial",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE",
      "ingredients": "Chardonnay-pinot noir Pinot menier"
    },
    {
      "id": 2102,
      "title": "Moët ice Demi-sec",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE",
      "ingredients": "Chardonnay-pinot noir Pinot menier"
    },
    {
      "id": 2103,
      "title": "Laurent Perrier La cuvee brut",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE",
      "ingredients": "Chardonnay-pinot noir Pinot menier"
    },
    {
      "id": 2201,
      "title": "Moët chandon",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE ROSE",
      "ingredients": "Chardonnay-pinot noir Pinot menier"
    },
    {
      "id": 2202,
      "title": " Moët ice Demi-sec",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE ROSE",
      "ingredients": "Chardonnay-pinot noir Pinot menier"
    },
    {
      "id": 2203,
      "title": "Laurent Perrier",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE ROSE",
      "ingredients": "Pinot noir"
    },
    {
      "id": 2204,
      "title": "Dom Pérignon",
      "category": "WINE LIST",
      "subCategory": "CHAMPAGNE ROSE",
      "ingredients": ""
    },
    {
      "id": 2301,
      "title": " White dry-semi-sweet Julia wine",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "500ml"
    },
    {
      "id": 2302,
      "title": " Pink dry-semi-sweet Julia wine",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "500ml"
    },
    {
      "id": 2303,
      "title": "Red dry-semi-sweet Julia wine",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "500ml"
    },
    {
      "id": 2304,
      "title": "Retsina Julia",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "500ml "
    },
    {
      "id": 2305,
      "title": "Retsina Vassiliki",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "500ml"
    },
    {
      "id": 2306,
      "title": "Ouzo Plomari",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "200ml"
    },
    {
      "id": 2307,
      "title": "Ouzo Varvagiannis",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "200ml"
    },
    {
      "id": 2308,
      "title": "Tsipouro Apostolakis",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "200ml"
    },
    {
      "id": 2309,
      "title": "Tsipouro Voluptuous",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "200ml"
    },
    {
      "id": 2317,
      "title": "Soft drinks",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "250ml"
    },
    {
      "id": 2319,
      "title": "Ice Tea",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 2320,
      "title": "Spirits Simple",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "glass"
    },
    {
      "id": 2321,
      "title": "Spirits Simple",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "bottle"
    },
    {
      "id": 2322,
      "title": "Spirits Special",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "glass"
    },
    {
      "id": 2323,
      "title": "Spirits Special",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "bottle"
    },
    {
      "id": 2324,
      "title": "Spirits Premium",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "glass"
    },
    {
      "id": 2325,
      "title": "Spirits Premium",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "bottle"
    },
    {
      "id": 2327,
      "title": "Red Bull",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "250ml"
    },
    {
      "id": 2328,
      "title": "Coca cola",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 2329,
      "title": "Fanta",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 2330,
      "title": "Sprite",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 2331,
      "title": "Water",
      "category": "DRINKS",
      "subCategory": "",
      "ingredients": "1L"
  },
  {
    id: 2332,
    title: "Gordon’s Space",
    category: "DRINKS",
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2333,
    title: "Pink Soda",
    category: "DRINKS",
    subCategory: "",
    ingredients: "",
  },
    {
      "id": 2401,
      "title": "Beer Amstel",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2402,
      "title": "Beer radler",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2403,
      "title": "Beer Heineken",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2404,
      "title": "Beer Fisher",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2405,
      "title": "Beer Erdinger",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2406,
      "title": "Beer Corona",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "330ml"
    },
    {
      "id": 2407,
      "title": "Fassbier",
      "category": "BEER",
      "subCategory": "",
      "ingredients": "400ml"
    },
    {
      id: 2408,
      image: null,
      title: "Beer Stella non-alcoholic",
      category: "BEER",
      subCategory: "",
      ingredients: "bottle",
  },

  ];
  